import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {getBuildLocator} from '../../../../../rest/locators'
import type {BuildId} from '../../../../../types'
import {makeResource} from '../../../../../utils/makeResource'
import {
  buildProblemsPreviewQuery,
  getBuildProblemsPreviewVariables,
} from '../../../../packages/BuildProblems/BuildProblemsPreview/BuildProblemsPreview.queries'
import {
  getCountsVariables,
  testsPreviewPanelCountsQuery,
} from '../../../../packages/Tests/TestsPreviewPanel/TestsPreviewPanel.queries'
import {
  getSnapshotDependenciesCountersVariables,
  snapshotDependenciesCountersQuery,
} from '../../../BuildInfoTable/SnapshotDependenciesCounters/SnapshotDependenciesCounters.queries'

import type {DetailsContentType} from './BuildDetailsContent'

export const BuildDetailsContentEntryPoint: EntryPoint<DetailsContentType, BuildId> = {
  root: makeResource(
    'BuildDetailsContent',
    () => import(/* webpackChunkName: "BuildDetailsContent" */ './BuildDetailsContent'),
  ),
  getPreloadProps: buildId => ({
    queries: {
      testCounts: {
        parameters: getRequest(testsPreviewPanelCountsQuery),
        variables: getCountsVariables(getBuildLocator(buildId)),
      },
      snapshotDependenciesCounters: {
        parameters: getRequest(snapshotDependenciesCountersQuery),
        variables: getSnapshotDependenciesCountersVariables(getBuildLocator(buildId)),
      },
      buildProblemsPreviewQuery: {
        parameters: getRequest(buildProblemsPreviewQuery),
        variables: getBuildProblemsPreviewVariables(getBuildLocator(buildId)),
      },
    },
  }),
}
